import { useMemo } from 'react';
import { AUTOMATION_EXTENSION } from 'automation-ui-action-features/constants/ActionTypes';
import { useAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
export function useExtensionDefinitionsInFlow(flow) {
  var _flow$createMetadata, _allExtensionsData$al;
  const actions = flow === null || flow === void 0 ? void 0 : flow.actions;
  const uniqueExtensionActionTypeIds = useMemo(() => actions ? Array.from(new Set(actions.toArray().filter(action => action.actionType === AUTOMATION_EXTENSION).map(action => action.actionTypeId))) : [], [actions]);
  const {
    data: allExtensionsData
  } = useAllExtensionDefinitions({
    objectType: flow.objectTypeId,
    createdSourceApp: ((_flow$createMetadata = flow.createMetadata) === null || _flow$createMetadata === void 0 ? void 0 : _flow$createMetadata.sourceApp) || undefined,
    actionTypeIdsToInclude: uniqueExtensionActionTypeIds
  });
  return (_allExtensionsData$al = allExtensionsData === null || allExtensionsData === void 0 ? void 0 : allExtensionsData.allExtensionDefinitions) !== null && _allExtensionsData$al !== void 0 ? _allExtensionsData$al : {};
}